import { Trash2Icon, Pen } from "lucide-react";
import React, { useState } from "react";
import Moment from "react-moment";
import { useRemoveWorkExperience } from "../../../../hooks/api/Tutors/UpdateProfile/useRemoveWorkExperience";
import { Modal } from "antd";
import UpdateWorkExperienceForm from "../../../Tutors/Profile/components/UpdateWorkExperienceForm";

const ExperienceCard = ({
  title,
  company,
  startDate,
  endDate,
  id,
  educationCount,
}: any) => {
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);

  const { mutate } = useRemoveWorkExperience();

  return (
    <div className="mb-[30px]">
      <p className="text-primary900 mb-1 W2STMedium">{title}</p>
      <p className="text-gray700 mb-1">{company}</p>
      <div className="text-gray700">
        <Moment format="YYYY" date={startDate} parse="YYYY" />
        {" - "}
        <Moment format="YYYY" date={endDate} parse="YYYY" />
      </div>

      <div className="mt-3 flex flex-row gap-6">
        <button
          onClick={() => setEditModalOpen(true)}
          className="flex gap-2 items-center text-green-700 text-[12px] cursor-pointer rounded-md"
        >
          <Pen size={15} />
          <span>Edit</span>
        </button>

        {educationCount > 1 && (
          <button
            onClick={() => setDeleteModalOpen(true)}
            className="flex gap-2 items-center text-red-700 text-[12px] cursor-pointer rounded-md"
          >
            <Trash2Icon size={15} />
            <span>Delete</span>
          </button>
        )}
      </div>

      <Modal
        width="600px"
        footer={null}
        open={editModalOpen}
        onCancel={() => setEditModalOpen(false)}
        title="Edit Work Experience"
      >
        <UpdateWorkExperienceForm
          initialValues={{
            id,
            title,
            company,
            startDate,
            endDate,
          }}
          onCancel={() => setEditModalOpen(false)}
        />
      </Modal>

      <Modal
        width="400px"
        footer={null}
        open={deleteModalOpen}
        onCancel={() => setDeleteModalOpen(false)}
        title={`Delete Experience from ${company}`}
      >
        <p className="text-gray700">
          Confirm that you'd like to delete this work experience. Note that this
          process is irreversible
        </p>
        <div className="flex gap-2 mt-4">
          <button
            onClick={() => {
              mutate(id, {
                onSuccess: () => {
                  setDeleteModalOpen(false);
                },
              });
            }}
            className="p-3 rounded-md bg-red-600 text-white flex-1"
          >
            Yes
          </button>
          <button
            onClick={() => setDeleteModalOpen(false)}
            className="p-3 rounded-md bg-primary100 text-primary700 flex-1"
          >
            No
          </button>
        </div>
      </Modal>

      {/* <div className="flex gap-5 mt-3">
        <span className="flex gap-2 items-center text-primary600 cursor-pointer">
          <AiOutlineEdit className="text-2xl" />
          <span>Edit</span>
        </span>
        <span className="flex gap-2 items-center text-error500 cursor-pointer">
          <FaRegTrashCan />
          <span>Delete</span>
        </span>
      </div> */}
    </div>
  );
};

export default ExperienceCard;
